var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-shipping-fees-page"},[_c('app-page-header',{attrs:{"title":"Taxas de envio de cartões"}}),_c('card-shipping-fees-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }